import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "icon"];

  connect() {
    // Track Turbo navigation for reliable back detection
    this.trackTurboNavigation();

    // Set initial state
    requestAnimationFrame(() => {
      this.setSmartHrefAndText();
    });
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener("turbo:visit", this.turboVisitHandler);
  }

  trackTurboNavigation() {
    // Listen for Turbo navigation to reliably track internal navigation
    this.turboVisitHandler = () => {
      sessionStorage.setItem("hasInternalNavigation", "true");
    };
    document.addEventListener("turbo:visit", this.turboVisitHandler);
  }

  setSmartHrefAndText() {
    try {
      const referrer = document.referrer;
      const currentUrl = window.location.href;
      const hasInternalNav =
        sessionStorage.getItem("hasInternalNavigation") === "true";

      console.log("Smart Back Debug:", {
        referrer,
        currentUrl,
        hasInternalNav,
      });

      // Method 1: Same-site referrer (most reliable)
      if (referrer && referrer.trim() !== "") {
        try {
          const referrerUrl = new URL(referrer);
          const currentPageUrl = new URL(currentUrl);

          if (referrerUrl.hostname === currentPageUrl.hostname) {
            console.log("Same site referrer detected");
            this.setBackNavigation(referrer);
            return;
          }
        } catch (e) {
          console.warn("Error parsing referrer URLs");
        }
      }

      // Method 2: Tracked internal navigation via Turbo
      if (hasInternalNav) {
        console.log("Internal navigation detected via Turbo tracking");
        this.setBackNavigation();
        return;
      }

      // Method 3: Fallback for all other cases
      console.log("Using fallback - no reliable back navigation detected");
      this.setFallbackHrefAndText();
    } catch (error) {
      console.warn("Smart back button error, using fallback:", error);
      this.setFallbackHrefAndText();
    }
  }

  setBackNavigation(href = null) {
    if (href) {
      // Use specific URL
      this.element.href = href;
    } else {
      // Use history.back()
      this.element.href = "#";
      this.element.onclick = (e) => {
        e.preventDefault();
        window.history.back();
        return false;
      };
    }
    this.setBackText();
  }

  setBackText() {
    if (this.hasTextTarget) {
      this.textTarget.textContent = "Back";
    }
    // Keep the existing back arrow icon
  }

  setFallbackHrefAndText() {
    // Default to Digital Release Calendar
    this.element.href = "/calendar";
    if (this.hasTextTarget) {
      this.textTarget.textContent = "View Full Calendar";
    }
    // Update icon to calendar icon
    if (this.hasIconTarget) {
      this.iconTarget.innerHTML = `
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      `;
    }
  }
}
